/* ──────────────────────────────────────────────────────────
   IMW Product v15 — Phase 1 client script (REBUILT for v15 mockup)

   - Variant change wiring (Digital's <variant-radios>)
   - Thumbnail click → select variant
   - Qty -/+ buttons
   - 2pm Promise live countdown to 14:00 UK time
   - Variant-aware updates: image, price (ex+inc VAT), SKU, mount card active state
   ────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.imw-v15').forEach(initSection);
    startCountdownLoop();
  }

  function initSection(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    if (!sectionId) return;

    // Variant change (Digital's <variant-radios> emits native change on its inputs)
    const variantRadios = sectionEl.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.addEventListener('change', function (e) {
        if (!(e.target && e.target.matches('input[type="radio"]'))) return;
        handleVariantChange(sectionEl, e.target);
      });
    }

    // Gallery carousel (arrows + dots + thumbnails) and the mounting help modal
    initGallery(sectionEl);
    initModal(sectionEl);

    // AJAX add-to-cart (opens the theme cart drawer)
    initAddToCart(sectionEl);

    // Qty -/+ buttons
    sectionEl.querySelectorAll('.imw-v15__qty').forEach(function (qtyEl) {
      const input = qtyEl.querySelector('input');
      qtyEl.querySelectorAll('.imw-v15__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const action = btn.getAttribute('data-action');
          const cur = parseInt(input.value, 10) || 1;
          if (action === 'inc') input.value = cur + 1;
          else if (action === 'dec') input.value = Math.max(1, cur - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', function () {
        const v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) input.value = 1;
      });
    });

    syncActiveThumb(sectionEl);
    updateArrivalText(sectionEl);
  }

  function handleVariantChange(sectionEl, radioInput) {
    const variantId = parseInt(radioInput.getAttribute('data-variant-id'), 10);
    if (!variantId) return;
    const variants = readVariantData(sectionEl);
    if (!variants) return;
    const variant = variants.find(function (v) { return v.id === variantId; });
    if (!variant) return;

    syncActiveThumb(sectionEl, variantId);
    updatePrices(sectionEl, variant);
    updateSku(sectionEl, variant);
    updateMainImage(sectionEl, variant);
    updateAddButton(sectionEl, variant);
    updateFormVariantId(sectionEl, variantId);
    updateUrlVariant(variantId);
  }

  // Keep the product form's hidden variant id in sync with the selected mounting.
  // Dawn's <variant-radios> can't parse this custom card markup, so we own this.
  function updateFormVariantId(sectionEl, variantId) {
    const input = sectionEl.querySelector('.imw-v15__form input[name="id"]');
    if (input && variantId) input.value = variantId;
  }
  // Reflect the selected variant in the URL (?variant=<id>) so it can be shared,
  // bookmarked, and reloads to the right variant — Shopify-standard behaviour.
  function updateUrlVariant(variantId) {
    if (!variantId || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* no-op */ }
  }
  // ─── AJAX add-to-cart ───
  // The section intentionally does NOT load Dawn's product-form.js (its spinner
  // selector differs), so we submit here and reuse the theme's <cart-drawer>.
  function initAddToCart(sectionEl) {
    const form = sectionEl.querySelector('.imw-v15__form');
    if (!form) return;
    const btn = form.querySelector('.imw-v15__cta-primary');
    const statusEl = form.querySelector('.imw-v15__form-status');

    form.addEventListener('submit', function (e) {
      // No cart route available → let the browser do a native POST (works, full reload).
      if (!window.routes || !window.routes.cart_add_url) return;
      e.preventDefault();
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;

      setBtnLoading(btn, true);
      clearFormStatus(statusEl);

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            showFormStatus(statusEl, res.description || res.message || 'Could not add to basket.');
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res); // re-renders drawer + cart-icon-bubble and opens the drawer
          } else {
            window.location = (window.routes.cart_url || '/cart');
            return;
          }
          // NOTE: intentionally NOT publishing PUB_SUB_EVENTS.cartUpdate here.
          // A theme/app subscriber re-renders the drawer from a stale (empty) state
          // when it fires, which re-injects the "your cart is empty" block on top of
          // the item we just added. renderContents() already refreshes the drawer AND
          // the header cart-icon-bubble, so the publish is redundant as well as harmful.
        })
        .catch(function (err) {
          console.error('[imw-v15] add to cart failed', err);
          showFormStatus(statusEl, 'Something went wrong. Please try again.');
        })
        .finally(function () { setBtnLoading(btn, false); });
    });
  }

  function setBtnLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
  }
  function clearFormStatus(el) {
    if (!el) return;
    el.textContent = '';
    el.classList.remove('is-error');
  }
  function showFormStatus(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-error');
  }

  function readVariantData(sectionEl) {
    const scriptEl = sectionEl.querySelector('variant-radios script[type="application/json"]');
    if (!scriptEl) return null;
    try { return JSON.parse(scriptEl.textContent); }
    catch (e) { console.warn('[imw-v15] Variant JSON parse failed', e); return null; }
  }

  function syncActiveThumb(sectionEl, variantId) {
    if (!variantId) {
      const checked = sectionEl.querySelector('input[type="radio"]:checked');
      if (checked) variantId = parseInt(checked.getAttribute('data-variant-id'), 10);
    }
    if (!variantId) return;
    var activeIndex = null;
    sectionEl.querySelectorAll('.imw-v15__thumb').forEach(function (t) {
      var isMatch = parseInt(t.getAttribute('data-variant-id'), 10) === variantId;
      t.classList.toggle('is-active', isMatch);
      if (isMatch) {
        var i = parseInt(t.getAttribute('data-index'), 10);
        if (!isNaN(i)) activeIndex = i;
      }
    });
    // Keep the mobile dots in sync when the variant changes from the mounting grid
    if (activeIndex !== null) {
      sectionEl.querySelectorAll('.imw-v15__dot').forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-index'), 10) === activeIndex);
      });
    }
  }

  // ─── Gallery carousel: arrows + dots + thumbnails ───
  // Works in two modes. Multi-variant: each slide maps to a variant (selecting it
  // also selects the variant). Single-variant: slides are product images and only
  // swap the main image. Thumbs carry data-index, data-image (full-size), and
  // optionally data-variant-id.
  function initGallery(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const mainImg = sectionEl.querySelector('#imw-main-img-' + sectionId);
    const thumbs = Array.prototype.slice.call(sectionEl.querySelectorAll('.imw-v15__thumb'));
    const dots = Array.prototype.slice.call(sectionEl.querySelectorAll('.imw-v15__dot'));
    const prevBtn = sectionEl.querySelector('.imw-v15__nav--prev');
    const nextBtn = sectionEl.querySelector('.imw-v15__nav--next');
    const count = Math.max(thumbs.length, dots.length);
    if (count <= 1) return;

    function currentIndex() {
      const active = sectionEl.querySelector('.imw-v15__thumb.is-active')
        || sectionEl.querySelector('.imw-v15__dot.is-active');
      if (active) {
        const i = parseInt(active.getAttribute('data-index'), 10);
        if (!isNaN(i)) return i;
      }
      return 0;
    }

    function setActive(index) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === index);
      });
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-index'), 10) === index);
      });
    }

    function goTo(index) {
      index = ((index % count) + count) % count; // wrap around
      const thumb = thumbs.filter(function (t) {
        return parseInt(t.getAttribute('data-index'), 10) === index;
      })[0];
      // Swap the main image when we have a full-size URL (image mode, or disabled variants)
      if (thumb && thumb.dataset.image && mainImg && mainImg.tagName === 'IMG') {
        mainImg.src = thumb.dataset.image;
      }
      // If the slide maps to a variant, select it (price/SKU/stock update via handleVariantChange)
      if (thumb && thumb.dataset.variantId) {
        const radio = sectionEl.querySelector(
          'input[type="radio"][data-variant-id="' + thumb.dataset.variantId + '"]'
        );
        if (radio && !radio.disabled && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setActive(index);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-index'), 10) || 0);
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
  }

  // ─── "Which mounting do I need?" help modal ───
  function initModal(sectionEl) {
    sectionEl.querySelectorAll('[data-imw-modal-open]').forEach(function (opener) {
      const modal = document.getElementById(opener.getAttribute('data-imw-modal-open'));
      if (!modal) return;
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        const dialog = modal.querySelector('.imw-v15__modal-dialog');
        if (dialog) dialog.focus();
      }
      function close() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      opener.addEventListener('click', open);
      modal.querySelectorAll('[data-imw-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    });
  }

  function updatePrices(sectionEl, variant) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const exEl = sectionEl.querySelector('#imw-price-ex-' + sectionId);
    const incEl = sectionEl.querySelector('#imw-price-inc-' + sectionId);
    if (exEl) {
      exEl.textContent = formatMoney(variant.price);
      exEl.setAttribute('data-price-cents', variant.price);
    }
    if (incEl) {
      const incCents = Math.round(variant.price * 1.20);
      incEl.textContent = formatMoney(incCents);
    }
  }

  function updateSku(sectionEl, variant) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const skuEl = sectionEl.querySelector('#imw-sku-' + sectionId);
    if (skuEl) skuEl.textContent = variant.sku || '—';
  }

  function updateMainImage(sectionEl, variant) {
    if (!variant.featured_image || !variant.featured_image.src) return;
    const sectionId = sectionEl.getAttribute('data-section-id');
    const imgEl = sectionEl.querySelector('#imw-main-img-' + sectionId);
    if (imgEl && imgEl.tagName === 'IMG') {
      const src = variant.featured_image.src.replace(
        /(_[\d]+x[\d]*)?(\.[a-zA-Z]+)(\?.*)?$/,
        '_1200x$2$3'
      );
      imgEl.src = src;
      imgEl.alt = variant.title || 'Product image';
    }
  }

  function updateAddButton(sectionEl, variant) {
    const btn = sectionEl.querySelector('.imw-v15__cta-primary');
    if (!btn) return;
    const textEl = btn.querySelector('.imw-v15__cta-text');
    if (variant.available) {
      btn.disabled = false;
      if (textEl) textEl.textContent = 'Add to basket';
    } else {
      btn.disabled = true;
      if (textEl) textEl.textContent = 'Sold out';
    }
  }

  // ─── 2pm Promise countdown ───
  // Counts down to next 14:00 UK time (Europe/London).
  // If currently past 14:00, target tomorrow 14:00.

  function startCountdownLoop() {
    updateAllCountdowns();
    setInterval(updateAllCountdowns, 30 * 1000); // update every 30s
  }

  function updateAllCountdowns() {
    document.querySelectorAll('.imw-v15').forEach(function (sectionEl) {
      updateCountdown(sectionEl);
      updateArrivalText(sectionEl);
    });
  }

  function updateCountdown(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const el = sectionEl.querySelector('#imw-countdown-' + sectionId);
    if (!el) return;

    const target = next2pmUK();
    const now = new Date();
    const diff = target - now;

    if (diff <= 0) {
      el.textContent = 'now';
      return;
    }

    const hours = Math.floor(diff / (60 * 60 * 1000));
    const mins = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));

    if (hours > 0) {
      el.textContent = hours + 'h ' + mins + 'm';
    } else {
      el.textContent = mins + 'm';
    }
  }

  function updateArrivalText(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const arrivalEls = [
      sectionEl.querySelector('#imw-arrival-' + sectionId),
      sectionEl.querySelector('#imw-cta-arrival-' + sectionId)
    ].filter(Boolean);

    if (!arrivalEls.length) return;

    // Arrival = next working day after dispatch.
    // If we're before 14:00 today: dispatch today → arrives tomorrow (or next working day).
    // If after 14:00: dispatch tomorrow → arrives day-after (or next working day after that).
    const ukNow = new Date(toLondonTime(new Date()));
    const past2pm = ukNow.getHours() >= 14;
    const arrival = nextWorkingDay(past2pm ? 2 : 1);
    const label = formatArrival(arrival);

    arrivalEls.forEach(function (el) { el.textContent = label; });
  }

  function next2pmUK() {
    // Returns a Date object (in viewer's local time) representing the next 14:00 UK time.
    const now = new Date();
    const londonNow = new Date(toLondonTime(now));
    const target = new Date(londonNow);
    target.setHours(14, 0, 0, 0);
    if (target <= londonNow) {
      // Past 14:00 today, target tomorrow
      target.setDate(target.getDate() + 1);
    }
    // Convert back from London time to local-equivalent
    const offsetDiff = londonNow.getTime() - now.getTime();
    return new Date(target.getTime() - offsetDiff);
  }

  function toLondonTime(date) {
    // Returns a string representing the date in London time zone, parseable by Date()
    return date.toLocaleString('en-US', { timeZone: 'Europe/London' });
  }

  function nextWorkingDay(daysAhead) {
    // daysAhead: number of working days forward from today (1 = tomorrow if weekday)
    const d = new Date();
    let added = 0;
    while (added < daysAhead) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay(); // 0=Sun, 6=Sat
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  function formatArrival(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return days[date.getDay()] + ' ' + date.getDate() + ' ' + months[date.getMonth()];
  }

  // ─── Money formatters ───

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    const pounds = cents / 100;
    return '£' + pounds.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatPriceWithPence(cents) {
    // Renders £207.<small>29</small> style — matches v15 mockup
    if (typeof cents !== 'number') return '';
    const pounds = Math.floor(cents / 100);
    const pence = String(cents % 100).padStart(2, '0');
    return '£' + pounds.toLocaleString('en-GB') + '.<small>' + pence + '</small>';
  }

  // Init lifecycle
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-imw-product-v15')) {
      init();
    }
  });
})();

/* ──────────────────────────────────────────────────────────
   PHASE 2 — Tab switching + variant-aware datasheet panel
   Patches onto the Phase 1 IIFE below using delegated handlers.
   ────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function initPhase2() {
    document.querySelectorAll('.imw-v15').forEach(initTabsAndDatasheet);
  }

  function initTabsAndDatasheet(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    if (!sectionId) return;

    // ─── Tab switching ───
    const tabs = sectionEl.querySelectorAll('.imw-v15__tab-btn');
    const panes = sectionEl.querySelectorAll('.imw-v15__tab-pane');
    if (tabs.length) {
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const target = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            const isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panes.forEach(function (p) {
            const isActive = p.getAttribute('data-pane') === target;
            p.classList.toggle('is-active', isActive);
            if (isActive) p.removeAttribute('hidden');
            else p.setAttribute('hidden', 'hidden');
          });
        });
        // Keyboard navigation: arrows move focus between tabs
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const arr = Array.from(tabs);
          const idx = arr.indexOf(tab);
          const next = e.key === 'ArrowRight'
            ? (idx + 1) % arr.length
            : (idx - 1 + arr.length) % arr.length;
          arr[next].focus();
          arr[next].click();
        });
      });
    }

    // ─── Variant change → update datasheet label, doc list labels, dimensions tab mount label, delivery stock line ───
    const variantRadios = sectionEl.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.addEventListener('change', function (e) {
        if (!(e.target && e.target.matches('input[type="radio"]'))) return;
        const variantId = parseInt(e.target.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        const mountLabel = readMountingLabel(sectionEl, variantId) || 'this';
        updateVariantLabels(sectionEl, sectionId, mountLabel);
      });
    }
  }

  function readMountingLabel(sectionEl, variantId) {
    const radio = sectionEl.querySelector('input[type="radio"][data-variant-id="' + variantId + '"]');
    if (radio) {
      const label = radio.getAttribute('data-mounting');
      if (label) return label;
      // fallback: read from the .imw-v15__m-code + .imw-v15__m-name children of its label
      const lbl = sectionEl.querySelector('label[for="' + radio.id + '"]');
      if (lbl) {
        const code = lbl.querySelector('.imw-v15__m-code');
        const name = lbl.querySelector('.imw-v15__m-name');
        if (code && name) return (code.textContent + ' ' + name.textContent).trim();
        if (code) return code.textContent.trim();
      }
    }
    return null;
  }

  function updateVariantLabels(sectionEl, sectionId, mountLabel) {
    // Datasheet panel sub-label
    const dsLabel = sectionEl.querySelector('#imw-ds-variant-' + sectionId);
    if (dsLabel && dsLabel.textContent.indexOf('For ') === 0) {
      dsLabel.textContent = 'For ' + mountLabel + ' mounting';
    }
    // Documents tab labels
    const docDs = sectionEl.querySelector('#imw-doc-ds-label-' + sectionId);
    const docDr = sectionEl.querySelector('#imw-doc-dr-label-' + sectionId);
    if (docDs) docDs.textContent = 'For ' + mountLabel + ' mounting';
    if (docDr) docDr.textContent = 'For ' + mountLabel + ' mounting · DWG + PDF';
    // Dimensions tab heading
    const dimMount = sectionEl.querySelector('#imw-dim-mount-' + sectionId);
    if (dimMount) dimMount.textContent = mountLabel;
    // Tech data tab SKU
    const checkedRadio = sectionEl.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      // SKU comes from variant JSON — read from the variant data
      const scriptEl = sectionEl.querySelector('variant-radios script[type="application/json"]');
      if (scriptEl) {
        try {
          const variants = JSON.parse(scriptEl.textContent);
          const variantId = parseInt(checkedRadio.getAttribute('data-variant-id'), 10);
          const variant = variants.find(function (v) { return v.id === variantId; });
          if (variant) {
            const skuEl = sectionEl.querySelector('#imw-spec-sku-' + sectionId);
            if (skuEl) skuEl.textContent = variant.sku || '—';
          }
        } catch (err) { /* swallow */ }
      }
    }
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPhase2);
  } else {
    initPhase2();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-imw-product-v15')) {
      initPhase2();
    }
  });
})();